(function () {
  const globalState = /** @type {{ __scienceHeroCounterInitialized?: boolean }} */ (window);
  if (globalState.__scienceHeroCounterInitialized) return;
  globalState.__scienceHeroCounterInitialized = true;

  const formatter = new Intl.NumberFormat('en-US');

  /** @param {HTMLElement} valueEl */
  const animateValue = (valueEl) => {
    if (valueEl.dataset.counterAnimated === 'true') return;

    const rawValue = (valueEl.dataset.scienceHeroCounterTarget || valueEl.textContent || '').trim();
    const match = rawValue.match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
    if (!match) return;

    const prefix = match[1] || '';
    const numericPart = match[2] || '';
    const suffix = match[3] || '';
    const target = Number(numericPart);
    if (!Number.isFinite(target)) return;

    const decimals = numericPart.includes('.') ? numericPart.split('.')[1].length : 0;
    const duration = 1800;
    const startTs = performance.now();
    const hasOvershoot = suffix.trim().toLowerCase() === 'x';

    valueEl.dataset.counterAnimated = 'true';

    const formatValue = (current) => {
      if (decimals > 0) {
        return `${prefix}${current.toFixed(decimals)}${suffix}`;
      }

      return `${prefix}${formatter.format(Math.round(current))}${suffix}`;
    };

    valueEl.textContent = formatValue(0);

    /** @param {number} now */
    const tick = (now) => {
      const elapsed = now - startTs;
      const progress = Math.min(elapsed / duration, 1);
      let current;

      if (hasOvershoot) {
        // Subtle back-out easing for multiplier stats.
        const c1 = 1.70158;
        const c3 = c1 + 1;
        const ease = 1 + c3 * Math.pow(progress - 1, 3) + c1 * Math.pow(progress - 1, 2);
        current = Math.min(target * 1.08, Math.max(0, target * ease));
      } else {
        const ease = 1 - Math.pow(1 - progress, 3);
        current = Math.min(target, Math.max(0, target * ease));
      }

      valueEl.textContent = formatValue(current);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        valueEl.textContent = formatValue(target);
      }
    };

    requestAnimationFrame(tick);
  };

  const initScienceHeroCounters = () => {
    const statValues = /** @type {NodeListOf<HTMLElement>} */ (
      document.querySelectorAll('.science-hero [data-science-hero-counter]')
    );

    if (!statValues.length) return;

    if (!('IntersectionObserver' in window)) {
      statValues.forEach((valueEl) => animateValue(valueEl));
      return;
    }

    const observedHeroes = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const hero = /** @type {HTMLElement} */ (entry.target);
          hero.querySelectorAll('[data-science-hero-counter]').forEach((valueEl) => {
            if (valueEl instanceof HTMLElement) animateValue(valueEl);
          });
          observer.unobserve(hero);
        });
      },
      { threshold: 0.35 }
    );

    statValues.forEach((valueEl) => {
      const hero = valueEl.closest('.science-hero');
      if (!(hero instanceof HTMLElement) || observedHeroes.has(hero)) return;
      observedHeroes.add(hero);
      observer.observe(hero);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScienceHeroCounters);
  } else {
    initScienceHeroCounters();
  }

  document.addEventListener('shopify:section:load', initScienceHeroCounters);
})();
